if (!window.Maximize.loadedScript.includes('product-bundle.js')) {
  window.Maximize.loadedScript.push('product-bundle.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data('xBundleSection', (sectionId, firstBlockId) => ({
        activeBlock: firstBlockId,
        initBundle() {
          if (Shopify.designMode) {
            document.addEventListener('shopify:block:select', (event) => {
              if (event.detail && event.detail.sectionId === sectionId) {
                this.activeBlock = event.detail.blockId;
              }
            });
          }
        }
      }));

      Alpine.data('xBundleBlock', (
        minimumItems,
        maximumItems,
        moneyFormat,
        productOnlyAddedOnce,
        discountType,
        discountValue,
        applyDiscountOncePerOrder,
        atbButtonText
      ) => ({
        productsBundle: [],
        loading: false,
        addToCartButton: "",
        bundleSummary: "",
        totalPrice: 0,
        errorMessage: false,
        showBundleContent: false,
        discountPrice: 0,
        viewBundle: false,
        loadedChooseOptions: {},
        maximumItems: 0,
        productOnlyAddedOnce: productOnlyAddedOnce,
        atbButtonText: atbButtonText,
        init() {
          this.addToCartButton = this.$el.querySelector(".button-atc");
          this.bundleSummary = this.$el.getElementsByClassName("bundle__summary__details")[0] || this.$el.closest(".bundle__summary__details ");
          this.maximumItems = maximumItems;
          this.totalPrice = formatMoney(0, moneyFormat);
          if (maximumItems <= minimumItems) this.maximumItems = minimumItems;
        },
        async loadChooseOptions(url, el, index) {
          const productCardWrapper = el.closest(".product-card-bundle")
          if (!productCardWrapper) return;

          let listOptionValuesIdSelected = productCardWrapper.dataset.listOptionValuesIdSelected ? productCardWrapper.dataset.listOptionValuesIdSelected.split(",") : "";
          let urlProduct = `${url}?option_values=${listOptionValuesIdSelected}&section_id=choose-option-product-bundle&page=${index}`;
  
          let destinationElm = productCardWrapper.querySelector(".choose-option");
          let loadingEl = productCardWrapper.querySelector(".icon-loading");
          if (this.loadedChooseOptions[urlProduct]) {
            destinationElm.innerHTML = this.loadedChooseOptions[urlProduct];
            setTimeout(() => {
              this.focusChooseOption(destinationElm);
            }, 500);
            return true;
          }
  
          try {
            if (loadingEl) {
              loadingEl.classList.remove("hidden");
            }
            const response = await fetch(urlProduct);
            const content = await response.text();
  
            const parser = new DOMParser();
            const parsedContent = parser.parseFromString(content, "text/html").getElementsByClassName("choose-option-content")[0].innerHTML;
             if (parsedContent) {
              if (destinationElm) {
                destinationElm.innerHTML = parsedContent;
              }
              if (!Shopify.designMode) {
                this.loadedChooseOptions[urlProduct] = parsedContent;
              }
            }
            if (loadingEl) {
              loadingEl.classList.add("hidden");
            }
          } catch (error) {
            console.error(error);
          }
          this.focusChooseOption(destinationElm);
        },
        focusChooseOption(el) {
          const closeButton = el.querySelector(".btn-close-choose-option");
          if (closeButton) {
            closeButton.focus();
          }
        },
        checkDisabledButton(productId) {
          return this.productsBundle.length >= maximumItems || (this.productOnlyAddedOnce && this.productsBundle.some(item => item.product_id == productId)) || !this.isAvailableButton
        },
        handleAddToBundle(el, hasOptions = false) {
          let newProduct = this.getCurrentProduct(el, hasOptions);
          this.productsBundle = [...this.productsBundle, newProduct];
          this.errorMessage = false;
          this.updateBundleContent(this.productsBundle);
        },
        getCurrentProduct(el, hasOptions) {
          let newProduct, productInfoElement;
          if (hasOptions) {
            let variantInfoElement = el.closest(".choose-options-content")?.querySelector('[type="application/json"][data-type="current-variant-info"]');
            productInfoElement = el.closest(".choose-options-content")?.querySelector('[type="application/json"][data-type="current-product-info"]');
            if (variantInfoElement && productInfoElement) {
              let variantData = JSON.parse(variantInfoElement.textContent);
              let productData = JSON.parse(productInfoElement.textContent); 
              newProduct = {
                id: variantData.id,
                product_id: productData.product_id,
                name: productData.name,
                option: variantData.title,
                featured_image: variantData.featured_image?.src || productData.featured_image,
                image_alt: variantData.featured_image?.alt || productData.featured_image_alt,
                quantity: 1,
                price: variantData.price
              }
            }
          } else {
            productInfoElement = el.parentElement.querySelector('[type="application/json"][data-type="current-product-info"]');
            if (productInfoElement) {
              let productData = JSON.parse(productInfoElement.textContent);
              newProduct = {
                id: productData.id,
                product_id: productData.product_id,
                name: productData.name,
                featured_image: productData.featured_image,
                image_alt: productData.featured_image_alt,
                quantity: 1,
                price: productData.price
              }
            }
          }
          return newProduct;
        },
        handleAddToCart(el) {
          let items = JSON.parse(JSON.stringify(this.productsBundle));
          items = items.reduce((data, product) => {
            data[product.id] ? data[product.id].quantity += product.quantity : data[product.id] = product;
            return data;
          }, {});
  
          this.loading = true;

          let cartSectionElement = document.querySelector("#CartDrawer");
          let cartSectionElementId = cartSectionElement && cartSectionElement.dataset.sectionId ? cartSectionElement.dataset.sectionId : false;
          if (window.Maximize.isCartPage) {
            cartSectionElement = document.querySelector("#MainCart__Items");
            cartSectionElementId = cartSectionElement && cartSectionElement.dataset.sectionId
          }
          const sectionsToRender = Alpine.store("xCartHelper").getSectionsToRender(cartSectionElementId);

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body:  JSON.stringify({ "items": items, "sections": sectionsToRender.map((section) => section.id) })
          }).then((response) => {
            return response.json();
          }).then((response) => {  
            if (response.status == '422') {
              const error_message = el.closest('.bundle__summary__wrapper')?.querySelector('.cart-warning');
              this.errorMessage = true;
              if (error_message) {
                error_message.textContent = response.description;
              }
              return;
            } 
            this.errorMessage = false;
            sectionsToRender.forEach((section => {
              const sectionElement = document.querySelector(section.selector);
              if (sectionElement) {
                if (response.sections[section.id])
                  sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
              }
            }));

            Alpine.store("xMiniCart").handleOpen();
            Alpine.store("xCartHelper").updateCurrentCountItem();
            document.dispatchEvent(new CustomEvent(`${CART_EVENT.cartUpdate}`, {
              bubbles: true,
              detail: {
                isItemCountChanged: true,
              }
            }));
          })
          .catch((error) => {
            console.error('Error:', error);
          }).finally(() => {
            this.loading = false;
            this.productsBundle = [];
            this.totalPrice = formatMoney(0, moneyFormat);
            this.discountPrice = formatMoney(0, moneyFormat);
            this.addToCartButton.setAttribute('disabled', 'disabled');
            this.updateBundleContent(this.productsBundle);
          })
        },
        updateBundleContent(productsBundle) {
          let total = productsBundle.map(item => item.price).reduce((total, item) => total + item, 0);
          
          if (productsBundle.length >= minimumItems) {
            this.addToCartButton?.removeAttribute('disabled');
            let discount = 0;
            let discountPrice = 0;
            if (!Number.isNaN(discountValue)) {
              discount = Number(discountValue);
  
              if (discountType == 'percentage' && Number.isInteger(discount) && discount >= 0 && discount <= 100) {
                discountPrice = Math.ceil(total - total * discount / 100);
              }
  
              if (discountType == 'amount' && discount >= 0) {
                discount = (Number.parseFloat(discountValue)).toFixed(2);
                if (applyDiscountOncePerOrder) {
                  discountPrice = total - discount * Shopify.currency.rate * 100;
                } else {
                  discountPrice = total - productsBundle.length * discount * Shopify.currency.rate * 100;
                }
              }
  
              if (discountPrice > 0) {
                this.discountPrice = formatMoney(discountPrice, moneyFormat);
              }
            } else {
              this.discountPrice = 0;
            }
          } else {
            this.discountPrice = 0;
            this.addToCartButton?.setAttribute('disabled', 'disabled');
          }
          this.totalPrice = formatMoney(total, moneyFormat);
          this.updateProgressBar(productsBundle.length);
        },
        removeBundle(indexItem) {
          let newProductsBundle = this.productsBundle.filter((item, index) => index != indexItem)
          this.productsBundle = newProductsBundle;
          this.updateBundleContent(newProductsBundle);
        },
        updateProgressBar(bundleLength) {
          let activeWidth = 0;
          if (this.bundleSummary) {
            activeWidth = bundleLength / minimumItems * 100;
            if(activeWidth > 100) activeWidth = 100;
          }
          this.bundleSummary.style.setProperty("--progress-bar-active-width", `${activeWidth}%`)
        }
      }));
    });
  });
}